import type { ServiceKey } from '../content/types'

/** Carousel order (SERVIZI 01–08). Single source of iteration order for routes, JSON-LD, menus. */
export const SERVICE_KEYS: readonly ServiceKey[] = [
  'progettazione', 'abbattimento', 'taglioPrato', 'pulizia', 'siepi', 'fresatura', 'treeClimbing', 'topiarie',
]
/** Public URL segments — frozen after cutover. */
export const SERVICE_SLUGS: Record<ServiceKey, { it: string; en: string }> = {
  progettazione: { it: 'progettazione-giardini',   en: 'garden-design' },
  abbattimento:  { it: 'abbattimento-controllato', en: 'controlled-tree-felling' },
  taglioPrato:   { it: 'taglio-prato',             en: 'lawn-mowing' },
  pulizia:       { it: 'pulizia-post-lavori',      en: 'post-work-cleanup' },
  siepi:         { it: 'tosatura-siepi',           en: 'hedge-trimming' },
  fresatura:     { it: 'fresatura-ceppi',          en: 'stump-grinding' },
  treeClimbing:  { it: 'tree-climbing',            en: 'tree-climbing' },
  topiarie:      { it: 'topiarie-artistiche',      en: 'topiary' },
}
/** Poster role (media/manifest.json) of each service — the key itself. */
export const SERVICE_MEDIA_ROLE: Record<ServiceKey, string> = Object.fromEntries(SERVICE_KEYS.map((k) => [k, k])) as Record<ServiceKey, string>
/** The reel each service page plays in its detail block, under the frozen carousel's public paths. */
export const SERVICE_VIDEO: Record<ServiceKey, string> = {
  progettazione: '/media/verde-vercelli/servizi/reel_01-noaudio.mp4',
  abbattimento:  '/media/verde-vercelli/servizi/reel_02-noaudio.mp4',
  taglioPrato:   '/media/verde-vercelli/servizi/reel_03-noaudio.mp4',
  pulizia:       '/media/verde-vercelli/servizi/reel_04-noaudio.mp4',
  siepi:         '/media/verde-vercelli/servizi/reel_05-noaudio.mp4',
  fresatura:     '/media/verde-vercelli/servizi/reel_06-noaudio.mp4',
  treeClimbing:  '/media/verde-vercelli/treeclimbing.mp4',
  topiarie:      '/media/verde-vercelli/servizi/reel_07-noaudio.mp4',
}
/**
 * "Related services" shown at the foot of each service page — three keys,
 * never the page's own key, ordered by relevance.
 */
export const RELATED_SERVICES: Record<ServiceKey, readonly [ServiceKey, ServiceKey, ServiceKey]> = {
  progettazione: ['taglioPrato', 'siepi', 'fresatura'],
  abbattimento:  ['treeClimbing', 'fresatura', 'pulizia'],
  taglioPrato:   ['siepi', 'pulizia', 'progettazione'],
  pulizia:       ['abbattimento', 'taglioPrato', 'siepi'],
  siepi:         ['topiarie', 'taglioPrato', 'pulizia'],
  fresatura:     ['abbattimento', 'progettazione', 'pulizia'],
  treeClimbing:  ['abbattimento', 'siepi', 'pulizia'],
  topiarie:      ['siepi', 'progettazione', 'taglioPrato'],
}
